import { useTranslation } from 'next-i18next'

export const useHublerDocumentsTranslation = () => {
  const { t } = useTranslation(['main.worker'])

  return (idDocument: number) => {
    switch (idDocument) {
      case 4:
        return t('main.worker:profile.my_documents.resume')
      case 6:
        return t('main.worker:profile.my_documents.add.diploma')
      default:
        return t('main.worker:profile.my_documents.other_document')
    }
  }
}
